<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="
    isShowDetail ||
    isShowOutboxMessageNumbersAuditPage ||
    isShowPhonebookRecipient ||
    isShowSendBulkDetail
      ? 'd-none'
      : ''
  "
  [id]="tabName"
  [config]="pageConfig"
  (onAdd)="goSendSmsPage('sendSMS')"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onSelectAll)="onSelectAll($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  [defaultFilters]="defaultFilters"
  [items]="items"
>
  <!---------------------------------------- Audit btns --------------------------------------->
  <!-- before-btns -->
  <div class="card-toolbar" before-btns>
    <!--organization-->
    <div class="tw-w-[300px] tw-ml-4 tw-mt-2" *ngIf="isShowOrganizationSearch">
      <organization-select-search
        type="descendantList"
        [(value)]="organizationId"
        (valueChange)="onChangeOrganization($event)"
      >
      </organization-select-search>
    </div>

    <!-- import smart send request btn -->
    <div
      [matTooltip]="'common.importRecepients' | translate"
      *ngIf="showExportItems"
    >
      <button
        (click)="importSmartSmsRecepients()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-file-import mdi-20px tw-p-0 text-success"></i>
      </button>
      <input
        #importRecepient
        type="file"
        style="display: none"
        (change)="importSartSmsRecepientsFile($event)"
        accept=".txt"
      />
    </div>

    <!-- ResendScheduledMessage btn -->
    <div [matTooltip]="'common.resendSMS' | translate">
      <button
        [disabled]="selectedIds?.length == 0"
        (click)="onGroupResend()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-email-sync mdi-20px tw-p-0 text-success"></i>
      </button>
    </div>

    <!-- group confirmation btn -->
    <div [matTooltip]="'common.groupConfirmation' | translate">
      <button
        [disabled]="selectedWaitingForConfirmIds?.length == 0"
        (click)="onConfirmSend()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-check-bold mdi-20px text-success p-0"></i>
      </button>
    </div>

    <!-- group reject btn -->
    <div [matTooltip]="'common.groupRejection' | translate">
      <button
        [disabled]="selectedWaitingForConfirmIds?.length == 0"
        (click)="onRejectSend()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-cancel mdi-20px text-danger p-0"></i>
      </button>
    </div>

    <!-- groupDeletion btn -->
    <div [matTooltip]="'common.groupDeletion' | translate">
      <button
        [disabled]="selectedIds?.length == 0"
        (click)="onGroupDeletion()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-trash-can-outline mdi-20px tw-p-0 text-danger"></i>
      </button>
    </div>
  </div>

  <!--------------------------------------- Table Content --------------------------------------->

  @let cols= tableColumns;

  <ng-container table-body *ngIf="items$ | async">
    @for(item of items$ | async; track item.id;let i = $index){
    <tr
      [class.tds-preloading]="pageConfig.loading"
      [class.tw-hidden]="pageConfig.loading"
      #row
      (click)="onActiveRow(row, i)"
      [class.row-active]="rowIndexSelected == i"
    >
      <!-- index -->
      <td
        class="tw-px-2 tw-text-center sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        [attr.position]="'right'"
      >
        {{ paginationModel?.firstIndex + i }}
      </td>

      <!-- checkbox -->
      <td
        class="sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        [attr.position]="'right'"
      >
        <div class="form-check tw-text-center">
          <input
            type="checkbox"
            class="form-check-input tw-mt-[1px] tw-mr-0"
            (click)="onAddSelectedId($event, item, row)"
            [attr.data-checkbox-id]="item.id"
          />
        </div>
      </td>

      <!-- id -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.id : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.id : tagName)?.size + 'px'
            : null
        "
        [attr.name]="columnNames.id"
        class="sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        [attr.position]="'right'"
        [attr.order]="(cols | columnData : columnNames.id : tagName)?.order"
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.id : tagName)?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <td-value copyToClipboard [value]="item?.[columnNames.id]"></td-value>
        </div>
      </td>

      <!-- smsText -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.smsText : tagName)?.isHide
        "
        [attr.name]="columnNames.smsText"
        class="msg-summary tw-text-center sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        [attr.position]="'right'"
        [attr.order]="
          (cols | columnData : columnNames.smsText : tagName)?.order
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.smsText : tagName)?.size + 'px'
            : null
        "
        [ngClass]="{
          ' tw-cursor-pointer': item?.smsText
        }"
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.smsText : tagName)?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <div
            class="tw-flex-center"
            textPopover
            [parentSelector]="tagName"
            [fullText]="item?.smsText"
            [hidePopover]="
              !showParent ||
              pageConfig?.isVisibleHelpPage ||
              pageConfig?.isVisibleAuditPage
            "
          >
            <p
              (click)="
                item?.voiceMessageId
                  ? getShortcutDetailModelApi(
                      item?.smsText,
                      item?.voiceMessageId
                    )
                  : ''
              "
              [ngClass]="item?.voiceMessageId ? 'hover:tw-text-blue-700' : ''"
              class="font-vazir-ui tw-text-gray-500 dark:!tw-text-gray-200 tw-font-normal max-one-row tw-w-[100px] tw-min-w-[100px]"
              [style.width]="
                innerWidth > 1024
                  ? (cols | columnData : columnNames.smsText : tagName)?.size -
                    40 +
                    'px'
                  : null
              "
            >
              {{ item?.[columnNames.smsText] | checkValue }}
            </p>
          </div>
        </div>
      </td>

      <!-- resellerName  -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.resellerName : tagName)?.isHide
        "
        [attr.name]="columnNames.resellerName"
        [attr.order]="
          (cols | columnData : columnNames.resellerName : tagName)?.order
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.resellerName : tagName)?.size +
              'px'
            : null
        "
        *ngIf="showReseller"
        class="msg-summary tw-text-center tw-cursor-pointer tw-py-1 tw-px-1"
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.resellerName : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <app-expand-text-click
            [smallText]="item?.[columnNames.resellerName] | reseller"
            [placement]="'left'"
            data-toggle="tooltip"
          >
            <span
              class="tw-text-center"
              small-text
              [innerHTML]="item?.[columnNames.resellerName] | reseller"
            ></span>
            <div
              full-text
              [innerHTML]="item?.[columnNames.resellerName] | reseller"
            ></div>
          </app-expand-text-click>
        </div>
      </td>

      <!-- recipientCount -->
      <td
        class="tw-px-1"
        [class.tw-hidden]="
          (cols | columnData : columnNames.recipientCount : tagName)?.isHide
        "
        [attr.name]="columnNames.recipientCount"
        [attr.order]="
          (cols | columnData : columnNames.recipientCount : tagName)?.order
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.recipientCount : tagName)?.size +
              'px'
            : null
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.recipientCount : tagName)
                  ?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            class="tw-text-sm"
            type="number"
            [value]="item?.[columnNames.recipientCount]"
          ></td-value>
        </div>
      </td>

      <!-- senderNumber -->
      <td
        class="tw-px-1"
        [class.tw-hidden]="
          (cols | columnData : columnNames.senderNumber : tagName)?.isHide
        "
        [attr.order]="
          (cols | columnData : columnNames.senderNumber : tagName)?.order
        "
        [attr.name]="columnNames.senderNumber"
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.senderNumber : tagName)?.size +
              'px'
            : null
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.senderNumber : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            copyToClipboard
            [value]="item?.[columnNames.senderNumber]"
          ></td-value>
        </div>
      </td>

      <!-- sendType -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.sendType : tagName)?.isHide
        "
        [attr.order]="
          (cols | columnData : columnNames.sendType : tagName)?.order
        "
        [attr.name]="columnNames.sendType"
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.sendType : tagName)?.size + 'px'
            : null
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.sendType : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <span [sendTypeStyle]="item?.[columnNames.sendType]">
            {{ item?.[columnNames.sendType] | enumToText : SendTypesEnumValues }}
          </span>
        </div>
      </td>

      <!-- campaign title -->
      <td
        class="tw-px-1"
        [class.tw-hidden]="
          (cols | columnData : columnNames.title : tagName)?.isHide
        "
        [attr.order]="(cols | columnData : columnNames.title : tagName)?.order"
        [attr.name]="columnNames.title"
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.title : tagName)?.size + 'px'
            : null
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.title : tagName)?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            class="tw-text-sm"
            copyToClipboard
            type="text"
            [value]="item?.[columnNames.title]"
          ></td-value>
        </div>
      </td>

      <!-- organizationName -->
      <td
        class="tw-px-1"
        [class.tw-hidden]="
          (cols | columnData : columnNames.organizationName : tagName)?.isHide
        "
        [attr.order]="
          (cols | columnData : columnNames.organizationName : tagName)?.order
        "
        [attr.name]="columnNames.organizationName"
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.organizationName : tagName)
                ?.size + 'px'
            : null
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.organizationName : tagName)
                  ?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            copyToClipboard
            type="text"
            [value]="item?.[columnNames.organizationName]"
          ></td-value>
        </div>
      </td>

      <!-- userName -->
      <td
        class="tw-px-1"
        [class.tw-hidden]="
          (cols | columnData : columnNames.userName : tagName)?.isHide
        "
        [attr.order]="
          (cols | columnData : columnNames.userName : tagName)?.order
        "
        [attr.name]="columnNames.userName"
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.userName : tagName)?.size + 'px'
            : null
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.userName : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            copyToClipboard
            type="text"
            [value]="item?.[columnNames.userName]"
          ></td-value>
        </div>
      </td>

      <!-- sendSubType -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.sendSubType : tagName)?.isHide
        "
        [attr.order]="
          (cols | columnData : columnNames.sendSubType : tagName)?.order
        "
        [attr.name]="columnNames.sendSubType"
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.sendSubType : tagName)?.size +
              'px'
            : null
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.sendSubType : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <span [sendSubTypeStyle]="item?.[columnNames.sendSubType]">
            {{ item?.[columnNames.sendSubType] | enumToText : SendSubTypesEnumValues }}
          </span>
        </div>
      </td>

      <!-- status -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.status : tagName)?.isHide
        "
        [attr.order]="(cols | columnData : columnNames.status : tagName)?.order"
        [attr.name]="columnNames.status"
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.status : tagName)?.size + 'px'
            : null
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.status : tagName)?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <span
            [matTooltip]="item?.[columnNames.status] | enumToText : QueueStatusEnumValues"
          >
            <i [queueStatusIcon]="item?.[columnNames.status]"></i>
          </span>
        </div>
      </td>

      <!-- failureCode -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.failureCode : tagName)?.isHide
        "
        [attr.order]="
          (cols | columnData : columnNames.failureCode : tagName)?.order
        "
        [attr.name]="columnNames.failureCode"
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.failureCode : tagName)?.size +
              'px'
            : null
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.failureCode : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <span
            [matTooltip]="
              item?.[columnNames.failureCode] | enumToText : FailureCodeEnumValues
            "
          >
            <i [failureCodeIcon]="item?.[columnNames.failureCode]"></i>
          </span>
        </div>
      </td>

      <!-- CreationLocation -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.creationLocation : tagName)?.isHide
        "
        [attr.order]="
          (cols | columnData : columnNames.creationLocation : tagName)?.order
        "
        [attr.name]="columnNames.creationLocation"
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.creationLocation : tagName)
                ?.size + 'px'
            : null
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.creationLocation : tagName)
                  ?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <span class="tw-text-sm">
            {{
              item?.[columnNames.creationLocation] | enumToText : CreationLocationEnumValues
            }}</span
          >
        </div>
      </td>

      <!-- isVoiceMessage -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.voiceMessageId : tagName)?.isHide
        "
        [attr.order]="
          (cols | columnData : columnNames.voiceMessageId : tagName)?.order
        "
        [attr.name]="columnNames.voiceMessageId"
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.voiceMessageId : tagName)?.size +
              'px'
            : null
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.voiceMessageId : tagName)
                  ?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            type="boolean"
            [value]="item?.[columnNames.voiceMessageId]"
          ></td-value>
        </div>
      </td>

      <!-- description -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.description : tagName)?.isHide
        "
        [attr.name]="columnNames.description"
        class="msg-summary tw-text-center"
        [attr.position]="'right'"
        [attr.order]="
          (cols | columnData : columnNames.description : tagName)?.order
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.description : tagName)?.size +
              'px'
            : null
        "
        [ngClass]="{
          ' tw-cursor-pointer': item?.description
        }"
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.description : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <div
            class="tw-flex-center"
            textPopover
            [parentSelector]="tagName"
            [fullText]="item?.description"
            [hidePopover]="
              !showParent ||
              pageConfig?.isVisibleHelpPage ||
              pageConfig?.isVisibleAuditPage
            "
          >
            <p
              (click)="
                item?.voiceMessageId
                  ? getShortcutDetailModelApi(
                      item?.description,
                      item?.voiceMessageId
                    )
                  : ''
              "
              [ngClass]="item?.voiceMessageId ? 'hover:tw-text-blue-700' : ''"
              class="font-vazir-ui tw-text-gray-500 dark:!tw-text-gray-200 tw-font-normal max-one-row tw-w-[100px] tw-min-w-[100px]"
              [style.width]="
                innerWidth > 1024
                  ? (cols | columnData : columnNames.description : tagName)
                      ?.size -
                    40 +
                    'px'
                  : null
              "
            >
              {{ item?.[columnNames.description] | checkValue }}
            </p>
          </div>
        </div>
      </td>

      <!-- created -->
      <td
        class="tw-px-1"
        [class.tw-hidden]="
          (cols | columnData : columnNames.created : tagName)?.isHide
        "
        [attr.order]="
          (cols | columnData : columnNames.created : tagName)?.order
        "
        [attr.name]="columnNames.created"
      >
        <td-value
          type="dateTimeWithSpace"
          [value]="item?.[columnNames.created]"
        ></td-value>
      </td>

      <!-- dateTimeNext -->
      <td
        class="sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        [attr.position]="'left'"
        [attr.order]="99"
        [attr.name]="columnNames.dateTimeNext"
      >
        <td-value
          type="dateTimeWithSpace"
          [value]="item?.[columnNames.dateTimeNext]"
        ></td-value>
      </td>

      <!-------------------------------- operations ------------------------------->
      <td
        class="sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8] operations-menu"
        [attr.position]="'left'"
        [attr.order]="99"
        [attr.name]="'action'"
      >
        <div class="tw-flex-start *:tw-mx-1 *:tw-cursor-pointer">
          <a [matMenuTriggerFor]="menu">
            <i
              class="mdi mdi-dots-vertical text-navyBlue mdi-20px text-vertical"
            ></i>
          </a>

          <!--* detail btn  -->
          <a
            *ngIf="item?.sendType != SendTypes.OTP"
            (click)="onDetail(item.id, item.sendType)"
            [matTooltip]="'common.detail' | translate"
          >
            <i
              class="mdi-text-box-search-outline mdi mdi-20px tw-rounded-md tw-p-1 text-sky bg-bright-sky tw-opacity-80 hover:tw-opacity-100"
            ></i>
          </a>

          <!--* receivers btn  -->
          <a
            *ngIf="
              item?.sendType != SendTypes.Phonebook &&
              item?.sendType != SendTypes.Bulk &&
              item?.sendType != SendTypes.Bulk2 &&
              item?.sendType != SendTypes.Club
            "
            [matTooltip]="'common.receivers' | translate"
            (click)="onShowReceivers(item.id, item?.created, item?.sendType)"
          >
            <i
              class="mdi-account-group mdi mdi-20px tw-rounded-md tw-p-1 text-info bg-bright-info tw-opacity-80 hover:tw-opacity-100"
            ></i>
          </a>

          <!--* confirm button -->
          <a
            *ngIf="
              userSession.userState()?.organizationIsConfirmMessage &&
              item.status == QueueStatus.WatingForConfirm
            "
            (click)="onConfirmSend(item.id)"
            [matTooltip]="'common.confirmSend' | translate"
          >
            <i
              class="mdi mdi-check-bold mdi-20px text-teal tw-rounded-md tw-p-1 bg-bright-teal tw-opacity-80 hover:tw-opacity-100"
            ></i>
          </a>
        </div>

        <!--* more buttons -->
        <mat-menu #menu="matMenu" xPosition="before">
          <!-- delivery Status Chart -->
          <div
            *ngIf="
              item?.sendType != SendTypes.Phonebook &&
              item?.sendType != SendTypes.Bulk &&
              item?.sendType != SendTypes.Bulk2 &&
              item?.sendType != SendTypes.Club
            "
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-purple border-bottom"
            (click)="deliveryStatusChart(item.id)"
          >
            <i
              class="mdi mdi-chart-arc mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-purple"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.deliveryStatusStats" | translate
            }}</span>
          </div>

          <!-- reject button -->
          <div
            mat-menu-item
            *ngIf="
              userSession.userState()?.organizationIsConfirmMessage &&
              item.status == QueueStatus.WatingForConfirm
            "
            class="tw-flex tw-justify-center tw-items-center text-danger border-bottom"
            (click)="onRejectSend(item.id)"
          >
            <i
              class="mdi mdi-cancel mdi-20px text-danger tw-ml-[10px] ltr:tw-mr-[10px]"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.rejectSend" | translate
            }}</span>
          </div>

          <!--user confirm button -->
          <div
            mat-menu-item
            *ngIf="
              item.status == QueueStatus.WaitingUserConfirmation &&
              tabName == PageNames.currentUserSendQueue
            "
            class="tw-flex tw-justify-center tw-items-center text-success border-bottom"
            (click)="onUserConfirmSend(item.id)"
          >
            <i
              class="mdi mdi-check-bold mdi-20px text-success tw-ml-[10px] ltr:tw-mr-[10px]"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.confirmSend" | translate
            }}</span>
          </div>

          <!-- edit button -->
          <div
            mat-menu-item
            *ngIf="
              !isSmartPeriodicSms(item.sendType, item.sendSubType) &&
              item.referenceId == null &&
              isRemoveOrUpdateIsAccessible(item?.status) &&
              item.sendType != SendTypes.Club
            "
            class="tw-flex tw-justify-center tw-items-center text-navyBlue border-bottom"
            (click)="onUpdateWithStatus(item.id, item.sendType, item.status)"
          >
            <i
              class="mdi mdi-pencil-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.edit" | translate
            }}</span>
          </div>

          <!-- delete button -->
          <div
            mat-menu-item
            *ngIf="
              isRemoveOrUpdateIsAccessible(item?.status) ||
              item.status == QueueStatus.BeforeAddJob
            "
            class="tw-flex tw-justify-center tw-items-center text-danger border-bottom"
            (click)="onDelete(item.id, item?.status)"
          >
            <i
              class="mdi mdi-trash-can-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-danger"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.delete" | translate
            }}</span>
          </div>

          <!-- resend button -->
          <div
            *ngIf="isShowResendBtn(item?.status)"
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-blue border-bottom"
            (click)="onSingleResend(item.id)"
          >
            <i
              class="mdi mdi-email-sync text-blue tw-ml-[10px] ltr:tw-mr-[10px] mdi-20px"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.resendSMS" | translate
            }}</span>
          </div>

          <!-- AddP2PScheduledMessageToQueue button -->
          <div
            *ngIf="
              item.sendType == SendTypes.P2P &&
              item.status == QueueStatus.FailedExtract
            "
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-navyBlue border-bottom"
            (click)="onAddP2PToQueue(item.id)"
          >
            <i
              class="mdi mdi-email text-navyBlue tw-ml-[10px] ltr:tw-mr-[10px] mdi-20px"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.addToQueue" | translate
            }}</span>
          </div>

          <!-- AddScheduledMessageToFileSendQueue button -->
          <div
            *ngIf="item.sendType == SendTypes.Single"
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-navyBlue border-bottom"
            (click)="onAddScheduleMessageToQueue(item.id)"
          >
            <i
              class="mdi mdi-email text-navyBlue tw-ml-[10px] ltr:tw-mr-[10px] mdi-20px"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.addToQueue" | translate
            }}</span>
          </div>

          <!-- addExistScheduledMessageToJob button -->
          <div
            *ngIf="item?.status == QueueStatus.BeforeAddJob"
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-navyBlue border-bottom"
            (click)="onAddToJob(item.id)"
          >
            <i
              class="mdi mdi-plus-box text-navyBlue tw-ml-[10px] ltr:tw-mr-[10px] mdi-20px"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.addToJob" | translate
            }}</span>
          </div>

          <!-- download excel button -->
          <div
            *ngIf="item?.fileLink"
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-blue border-bottom"
            (click)="onDownloadFile(item?.fileLink)"
          >
            <i
              class="mdi mdi-download text-blue tw-ml-[10px] ltr:tw-mr-[10px] mdi-20px"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.downloadExcel" | translate
            }}</span>
          </div>

          <mat-divider *ngIf="showExportItems"></mat-divider>
          <div
            *ngIf="showExportItems && item.sendType == SendTypes.Smart"
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-navyBlue"
            (click)="onExportRecepientClick(item.id)"
          >
            <i
              class="mdi mdi-file-export mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.exportRecepient" | translate
            }}</span>
          </div>
        </mat-menu>
      </td>
    </tr>
    }
  </ng-container>
</app-page-template>

<!-- Detail -->
@if(isShowDetail){
<app-send-queue-detail
  [model]="detailModel"
  [isShowSmartRecipient]="isShowSmartRecipientInDetail"
  [isShowPhonebookRecipient]="isShowPhonebookRecipientInDetail"
  (closePage)="isShowDetail = false; showParent = true; getParentQueryString()"
>
</app-send-queue-detail>
}

<!-- Send Bulk Detail -->

@if(isShowSendBulkDetail){
<app-send-queue-send-balk-detail
  [model]="detailModel"
  [scheduledMessageId]="scheduledMessageId"
  (closePage)="
    isShowSendBulkDetail = false; showParent = true; getParentQueryString()
  "
>
</app-send-queue-send-balk-detail>
}

<!-- Edit -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <!-- sendType != SendTypes.Bulk -->
  <ng-container
    *ngIf="
      !sendBalkFormPageConfig?.isEditMode &&
      !sendBalk2FormPageConfig?.isEditMode
    "
  >
    <!-- sendType == SendTypes.Single -->
    <app-send-sms
      *ngIf="formPageConfig?.editData?.sendType == SendTypes.Single"
      [formPageConfig]="formPageConfig"
      (closeFormPage)="getFormResponse($event); getTableData()"
    >
    </app-send-sms>

    <!-- sendType != SendTypes.Single -->
    <app-base-edit-send-sms
      *ngIf="
        formPageConfig?.editData?.sendType != SendTypes.Single &&
        formPageConfig?.editData?.sendType != SendTypes.Dynamic
      "
      [sendType]="formPageConfig?.editData?.sendType"
      [formPageConfig]="formPageConfig"
      [selectedPhonebooks]="this.selectedPhonebooks"
      (closeFormPage)="getFormResponse($event); getTableData()"
    >
    </app-base-edit-send-sms>

    <!-- sendType == SendTypes.Dynamic -->
    <app-edit-dynamic-send-sms
      *ngIf="formPageConfig?.editData?.sendType == SendTypes.Dynamic"
      [dynamicData]="dynamicData"
      (closeFormPage)="getFormResponse($event); getTableData()"
    >
    </app-edit-dynamic-send-sms>
  </ng-container>

  <!-- sendType == SendTypes.Bulk -->
  @if(sendBalkFormPageConfig?.isEditMode){
  <app-send-balk-sms
    [formPageConfig]="sendBalkFormPageConfig"
    (closeFormPage)="getFormResponse($event); getTableData()"
  >
  </app-send-balk-sms>
  }

  <!-- sendType == SendTypes.Bulk2 -->
  @if(sendBalk2FormPageConfig?.isEditMode){
  <app-send-balk-sms2
    [formPageConfig]="sendBalk2FormPageConfig"
    (closeFormPage)="getFormResponse($event); getTableData()"
  >
  </app-send-balk-sms2>
  }
</ng-container>

<!-- Audit -->

@if(pageConfig?.isVisibleAuditPage){
<app-audit
  [service]="currentService"
  methodName="scheduledMessagesGetScheduledMessagesAudit"
  (hidePage)="onHideAuditPage()"
>
</app-audit>
}

<!-- statusDateTime audit page -->

@if(isShowOutboxMessageNumbersAuditPage){
<app-audit
  [service]="OutboxMessageNumbersService"
  methodName="outboxMessageNumbersGetOutboxMessageNumbersAudit"
  [sortReferenceId]="false"
  (hidePage)="
    isShowOutboxMessageNumbersAuditPage = false;
    showParent = true;
    getParentQueryString()
  "
>
</app-audit>
}

<!---------------------------------------- help --------------------------------------->
@if(pageConfig?.isVisibleHelpPage){
<app-help-page
  [menuTitle]="
    tabName == PageNames.currentUserSendQueue
      ? 'CurrentUserSendQueue'
      : tabName == PageNames.sendQueue
      ? 'SendQueue'
      : 'UsersSendQueue'
  "
  (hidePage)="onHideHelpPage()"
  [title]="pageConfig.title"
>
</app-help-page>
}
